import { type Icon } from '@/constants/Icons';
import { type FilterByType } from '@/helpers';
import { type Dispatch, type JSX, type Reducer } from 'react';

export interface Step<T extends StepFormState<T>, PropType extends Record<string, any>> {
  name: string;
  isValid: (state: T) => string | boolean;
  renderStep: (state: T, dispatch: Dispatch<StepFormAction<T>>, props: PropType) => JSX.Element;
  extraButton?: { icon: Icon; title: string };
}

export interface StepFormState<T extends StepFormState<T>> {
  currentStep: number;
  steps: Step<T, Record<string, any>>[];
  stepReady?: boolean;
  finalStepReady?: boolean;
}

export type StepFormAction<T extends StepFormState<T>> =
  | { type: 'next' }
  | { type: 'previous' }
  | { type: 'stepReady'; data?: boolean }
  | { type: 'finalStepReady'; data?: boolean }
  | { type: 'jumpToStep'; currentStep: number }
  | { type: 'update'; id: keyof FilterByType<T, Record<string, any>>; data: any }
  | { type: 'updateArray'; id: keyof FilterByType<T, Record<string, any>>; data: any };

export type StepFormReducer<T extends StepFormState<T>> = Reducer<T, StepFormAction<T>>;
export type StepFormDispatch<T extends StepFormState<T>> = Dispatch<StepFormAction<T>>;
